/* global axios */
import ApiClient from './ApiClient';

class WebHooks extends ApiClient {
  constructor() {
    super('webhooks', { accountScoped: true });
  }

  operationsSummary(id, params = {}) {
    return axios.get(`${this.url}/${id}/operations_summary`, { params });
  }

  preflight(id) {
    return axios.post(`${this.url}/${id}/preflight`);
  }

  reconcileUnknown(id, deliveryId, data) {
    return axios.post(
      `${this.url}/${id}/deliveries/${deliveryId}/reconcile_unknown`,
      data
    );
  }

  replayDelivery(id, deliveryId, data) {
    const replayKey = data?.replay_key;
    const config = replayKey
      ? { headers: { 'Idempotency-Key': replayKey } }
      : undefined;

    return axios.post(
      `${this.url}/${id}/deliveries/${deliveryId}/replay`,
      data,
      config
    );
  }
}

export default new WebHooks();
